import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/stores/auth';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, initialized, init, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!initialized) init();
  }, [initialized, init]);

  if (!initialized || loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-bone">
        <div className="h-1 w-24 overflow-hidden rounded-full bg-bone-deep">
          <div className="h-full w-1/3 animate-[shimmer_1.2s_ease-in-out_infinite] bg-accent" />
        </div>
        <style>{`@keyframes shimmer{0%{transform:translateX(-100%)}100%{transform:translateX(300%)}}`}</style>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
